// Chakra imports
import {Box, Flex} from "@chakra-ui/react";
import InvoicesAdminTable from "../../../components/tables/InvoicesAdminTable";
import React, {useEffect, useState} from "react";
import {getData} from "../../../services/api";

export default function InvoicesAdmin() {

    const [tableData, setTableData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const columnsData = [
        {
            Header: "Nr.",
            accessor: "uuid",
        },
        {
            Header: "BETRAG",
            accessor: "amount",
        },
        {
            Header: "STATUS",
            accessor: "status",
        },
        {
            Header: "KUNDE",
            accessor: (row) => `${row.user.firstname} ${row.user.lastname} ${row.user.email}`,
        },
        {
            Header: "INSERAT",
            accessor: (row) => row.rental ? `${row.rental.title} ${row.rental.uuid}` : '',
        },
        {
            Header: "",
            accessor: "url",
        },
    ];

    useEffect(() => {
        // Define an async function to fetch data
        const fetchData = async () => {
            try {
                const result = await getData('/api/invoices');
                setTableData(result.data);
                setLoading(false);
            } catch (error) {
                setError(error.message);
                setLoading(false);
            }
        };

        // Call the async function
        fetchData();
    }, []);

    return (
        <Box pt={{base: "130px", md: "80px", xl: "80px"}}>
            {loading ? (
                <div>Loading...</div>
            ) : error ? (
                <div>Error: {error}</div>
            ) : tableData ? (
                <InvoicesAdminTable columnsData={columnsData} tableData={tableData}/>
            ) : (
                <div>Keine Daten gefunden</div>
            )}
        </Box>
    );
}
